var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.newCom)?_c('Cgq',_vm._b({},'Cgq',_vm.$attrs,false)):_c('CgqNew',_vm._b({},'CgqNew',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }